/**
 * Rules for when pallet packing is permitted.
 *
 * Pallet creation and pallet scan-mode are only allowed when the shipment is
 * routed through the "Other" shipping gateway (OTHER_FP) AND the shipment
 * method is one of the freight/other methods (FTL, LTL, Others).
 */
export var PALLET_ALLOWED_GATEWAY_CONFIG_ID = 'OTHER_FP';
export var PALLET_ALLOWED_SHIPMENT_METHOD_ENUM_IDS = [
    'ShMthFTL',
    'ShMthLTL',
    'ShMthOthers'
];
export var isPalletPackingAllowed = function (shipmentData, shipmentRouteSegments) {
    var _a, _b, _c;
    var gatewayId = ((_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.shippingGatewayConfigId) ||
        (shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shippingGatewayConfigId);
    var methodId = ((_b = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.curCarrierShipmentMethod) === null || _b === void 0 ? void 0 : _b.shipmentMethodEnumId) ||
        ((_c = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.orderCarrierShipmentMethod) === null || _c === void 0 ? void 0 : _c.shipmentMethodEnumId);
    return (gatewayId === PALLET_ALLOWED_GATEWAY_CONFIG_ID &&
        !!methodId &&
        PALLET_ALLOWED_SHIPMENT_METHOD_ENUM_IDS.includes(methodId));
};
export var PALLET_DISABLED_TOOLTIP = 'Set the shipping gateway to Other and a shipment method of FTL, LTL, or Others to enable pallet packing.';
